import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardMenuOpen: false,
      analyticsMenuOpen: false,
      reportMenuOpen: false
    };
  }

  toggleMenuState(menuState) {
    const body = document.querySelector('body');
    if (!body.classList.contains('sidebar-icon-only')) {
      this.setState(prevState => ({
        dashboardMenuOpen: menuState === 'dashboardMenuOpen' ? !prevState.dashboardMenuOpen : false,
        analyticsMenuOpen: menuState === 'analyticsMenuOpen' ? !prevState.analyticsMenuOpen : false,
        reportMenuOpen: menuState === 'reportMenuOpen' ? !prevState.reportMenuOpen : false
      }));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    const body = document.querySelector('body');
    document.querySelector('#sidebar').classList.remove('active');
    
    if (!body.classList.contains('sidebar-icon-only')) {
      const dropdownPaths = [
        {path:'/pages/dashboard', state: 'dashboardMenuOpen'},
        {path:'/pages/analytics', state: 'analyticsMenuOpen'},
        {path:'/pages/report', state: 'reportMenuOpen'},
      ];

      this.setState({
        dashboardMenuOpen: false,
        analyticsMenuOpen: false,
        reportMenuOpen: false
      }, () => {
        dropdownPaths.forEach((obj => {
          if (this.isPathActive(obj.path)) {
            this.setState({ [obj.state]: true });
          }
        }));
      });
    }
  }

  render () {
    const body = document.querySelector('body');
    const isIconOnly = body.classList.contains('sidebar-icon-only');
    
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li className={ this.isPathActive('/pages/dashboard') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.dashboardMenuOpen ? 'nav-link menu-expanded' : 'nav-link' } 
                 onClick={ () => this.toggleMenuState('dashboardMenuOpen') } 
                 data-toggle="collapse">
              <i className="bi bi-columns-gap menu-icon fw-bold"></i>
              <span className="menu-title fw-bold"><Trans>Dashboard</Trans></span>
              {!isIconOnly && <i className={`bi bi-chevron-down menu-arrow fw-bold ${this.state.dashboardMenuOpen ? 'rotate-180' : ''}`}></i>}
            </div>
            <Collapse in={ !isIconOnly && this.state.dashboardMenuOpen }>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className={ this.isPathActive('/pages/dashboard') ? 'nav-link active' : 'nav-link' } to="/pages/dashboard">
                    <i className="bi bi-chevron-right fw-bold"></i>
                    <span className="fw-bold"><Trans>Dashboard</Trans></span>
                  </Link>
                </li>
              </ul>
            </Collapse>
          </li>
          <li className={ this.isPathActive('/pages/analytics') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.analyticsMenuOpen ? 'nav-link menu-expanded' : 'nav-link' }
                 onClick={ () => this.toggleMenuState('analyticsMenuOpen') }
                 data-toggle="collapse">
              <i className="bi bi-file-earmark-bar-graph menu-icon fw-bold"></i>
              <span className="menu-title fw-bold"><Trans>Analytics</Trans></span>
              {!isIconOnly && <i className={`bi bi-chevron-down menu-arrow fw-bold ${this.state.analyticsMenuOpen ? 'rotate-180' : ''}`}></i>}
            </div>
            <Collapse in={ !isIconOnly && this.state.analyticsMenuOpen }>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className={ this.isPathActive('/pages/analytics') ? 'nav-link active' : 'nav-link' } to="/pages/analytics">
                    <i className="bi bi-chevron-right fw-bold"></i>
                    <span className="fw-bold"><Trans>Analytics</Trans></span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={ this.isPathActive('/pages/itemdimensionanalysis') ? 'nav-link active' : 'nav-link' } to="/pages/itemdimensionanalysis">
                    <i className="bi bi-chevron-right fw-bold"></i>
                    <span className="fw-bold"><Trans>Item Dimension Analysis</Trans></span>
                  </Link>
                </li>
              </ul>
            </Collapse>
          </li>
          <li className={ this.isPathActive('/pages/report') ? 'nav-item active' : 'nav-item' }>
            <div className={ this.state.reportMenuOpen ? 'nav-link menu-expanded' : 'nav-link' }
                 onClick={ () => this.toggleMenuState('reportMenuOpen') }
                 data-toggle="collapse">
              <i className="bi bi-file-earmark-spreadsheet menu-icon fw-bold"></i>
              <span className="menu-title fw-bold"><Trans>Report</Trans></span>
              {!isIconOnly && <i className={`bi bi-chevron-down menu-arrow fw-bold ${this.state.reportMenuOpen ? 'rotate-180' : ''}`}></i>}
            </div>
            <Collapse in={ !isIconOnly && this.state.reportMenuOpen }>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className={ this.isPathActive('/pages/report') ? 'nav-link active' : 'nav-link' } to="/pages/report">
                    <i className="bi bi-chevron-right fw-bold"></i>
                    <span className="fw-bold"><Trans>Report</Trans></span>
                  </Link>
                </li>
              </ul>
            </Collapse>
          </li>
        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });

    // Listen for sidebar-icon-only class changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          if (!body.classList.contains('sidebar-icon-only')) {
            // Reset states when expanding
            this.setState({
              dashboardMenuOpen: this.isPathActive('/pages/dashboard'),
              analyticsMenuOpen: this.isPathActive('/pages/analytics'),
              reportMenuOpen: this.isPathActive('/pages/report')
            });
          }
        }
      });
    });

    observer.observe(body, {
      attributes: true
    });
  }

  componentWillUnmount() {
    // Clean up event listeners if component unmounts
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.removeEventListener('mouseover', () => {});
      el.removeEventListener('mouseout', () => {});
    });
  }
}

export default withRouter(Sidebar);